import Modal from "../components/DetailModal";

function Test() {
  return (
    <div>
      <Modal />
    </div>
  );
}

export default Test;
